import { useVisitorData } from '@mentimeter/visitor/visitor-data';
import { useDevelopmentFlag } from '@mentimeter/development-tools/hooks';
import { hasMonthlyBillingEnabled } from '../utils/hasMonthlyBillingEnabled';

export function useMonthlyBilling() {
  const { visitorData, isLoading } = useVisitorData();
  const overrideMonthlyBilling = useDevelopmentFlag('monthly-billing');
  const monthlyBillingIsSupported =
    overrideMonthlyBilling === 'on' ||
    hasMonthlyBillingEnabled(visitorData?.country);

  return { monthlyBillingIsSupported, isLoading };
}
